import { FC } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as RubbishSVG } from "go-core/images/svg/actions/rubbish.svg";

interface ActionProps {
	name?: string;
}

const RemoveAction: FC<ActionProps> = (props: ActionProps) => {
	const { t } = useTranslation();
	const name = props.name ? props.name : t("common.action.remove", { ns: "lib" });
	return (
		<div className="d-flex">
			<div className="common-actions icon">
				<RubbishSVG />
			</div>
			{name}
		</div>
	);
};
export default RemoveAction;
